import PeopleEducationItem from './PeopleEducationItem';

export { type PeopleEducationItemProps } from './PeopleEducationItem';
export default PeopleEducationItem;
